<template>
  <div>
    <Niches />
  </div>
</template>

<script>
import Niches from '@/components/Niches';
export default {
  nuxtI18n: {
    paths: {
      en: '/niches',
      de: '/nischen',
      es: '/nichos',
      pt: '/nichos'
    }
  },
  components: {
    Niches
  },
  async fetch({ store }) {
    await Promise.all([
      store.dispatch('niches/LOAD_NICHES'),
      store.dispatch('listings/GET_LIST', {
        name: 'featured_niches',
        type: 'niches',
        exp: store.getters['experience/getMerch']
      })
    ]);
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
}
</style>
